import { useEffect, useMemo, useRef, useState } from 'react';

const getOffetTop = (element: HTMLElement, offset = 200) => {
  // Adjust this value to set the space from the top
  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = element.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;

  return offsetPosition;
};

export const useToggleLessMore = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const categoryRef = useRef<HTMLUListElement | null>(null);
  const contentRef = useRef<HTMLDivElement | null>(null);

  const categoryHeight = categoryRef.current?.scrollHeight;
  const contentHeight = contentRef.current?.scrollHeight;

  // Content > Category and Content > 500px
  const shouldHaveExpand = useMemo(
    () => contentHeight && categoryHeight && contentHeight > categoryHeight && contentHeight > 500,
    [contentHeight, categoryHeight],
  );

  const scrollToTop = () => {
    const element = document.getElementById('section-information');

    if (element) {
      window.scrollTo({
        top: getOffetTop(element, 150),
      });
    }
  };

  const toggle = () => {
    setIsExpanded(!isExpanded);
    if (isExpanded) scrollToTop();
  };

  return {
    isExpanded: isExpanded || !shouldHaveExpand,
    categoryRef,
    contentRef,
    categoryHeight,
    contentHeight,
    shouldHaveExpand,
    toggle,
    setIsExpanded,
  };
};

